module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.ed0943f2.svg";